import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faCaretUp } from "@fortawesome/free-solid-svg-icons"

export const CaretUp = (props) => {
  return <FontAwesomeIcon faIcon={faCaretUp} {...props} />
}
